
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unstable/dnd-kit",
      function () {
        return require("private-next-pages/unstable/dnd-kit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unstable/dnd-kit"])
      });
    }
  